import React from 'react';
import type { SectionProps } from './types';
import { ColorCustomizationPanel } from '../../shared/ColorInput';
import { getColorFieldsForComponent } from '../../shared/colorFieldUtils';
import { useCustomColors } from '../../../../contexts/CustomColorsContext';

export const ColorSection: React.FC<SectionProps> = ({ data, setFormData }) => {
  const themeColors = useCustomColors();

  const updateCustomColor = (key: string, value: string | null) => {
    setFormData({
      ...data,
      customColors: { ...data.customColors, [key]: value },
    });
  };

  // Get theme-aware color defaults
  const colorFields = getColorFieldsForComponent('countdown-timer', themeColors);

  return (
    <ColorCustomizationPanel
      title="Color Customization"
      description="Customize countdown timer colors. Leave empty to use defaults."
      customColors={data.customColors as Record<string, string | null | undefined>}
      colorFields={colorFields}
      onUpdateColor={updateCustomColor}
    />
  );
};
